import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// The original design's stylesheets, unchanged. `polish.css` only adds styles
// for elements that did not exist before (toasts, skeletons, new pages).
import './styles/styles.css';
import './styles/connix-luxe.css';
import './styles/polish.css';
import './styles/admin.css';

import App from './App.jsx';
import { SiteProvider } from './context/SiteProvider.jsx';
import { CartProvider } from './context/CartProvider.jsx';
import { AuthProvider } from './context/AuthProvider.jsx';
import { ToastProvider } from './context/ToastProvider.jsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <SiteProvider>
            <AuthProvider>
              <CartProvider>
                <App />
              </CartProvider>
            </AuthProvider>
          </SiteProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
